import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";

import PageHeader from "./PageHeader";
import NotFoundPage from "./NotFoundPage";
type NotFoundPageType = React.ComponentType<Record<string, unknown>>;
const NotFoundPageAny = NotFoundPage as unknown as NotFoundPageType;
import Loader from "./Loader";
import RichText from "./RichText";
import { withContentData, type ContentQueryProps } from "api/queries/useContent";

interface ContentPageOwnProps extends WithTranslation {
  params: { code: string };
}

type ContentPageProps = ContentPageOwnProps & ContentQueryProps;

function ContentPage({ t, params, contents, contentsLoaded }: ContentPageProps) {
  if (!contentsLoaded) {
    return (
      <div className="Page ContentPage">
        <div className="Page-content ContentPage-content">
          <Loader />
        </div>
      </div>
    );
  }

  const page = contents["page_" + params.code];
  if (!page || !page.title) {
    return <NotFoundPageAny />;
  }

  const showHeaderExcerpt =
    !!page.excerpt && page.excerpt.trim().toLowerCase() !== page.title.trim().toLowerCase();

  return (
    <div className="Page ContentPage">
      <div className="Page-content ContentPage-content">
        <PageHeader
          breadcrumbs={[
            { label: t("navigation.label_home"), to: BASE_PATH + "/" },
            { label: page.title },
          ]}
          title={page.title}
          textHtml={showHeaderExcerpt ? page.excerpt : null}
        />

        <article className="ContentPage-card">
          <RichText className="ContentPage-text" html={page.content} />
        </article>
      </div>
    </div>
  );
}

export default compose(withTranslation(), withContentData)(ContentPage);
